/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReduxStore } from '../../Constants/App';

type AppState = {
  appState: string;
  pendingCustomerOneTimeJobApprovalRefreshTrigger: number;
};

const initialState: AppState = {
  appState: '',
  pendingCustomerOneTimeJobApprovalRefreshTrigger: 0,
};

export const appStateSlice = createSlice({
  name: ReduxStore.appState,
  initialState,
  reducers: {
    setAppState: (state, action: PayloadAction<string>) => {
      state.appState = action.payload;
    },
    triggerPendingCustomerOTJApprovalRefresh: (state) => {
      state.pendingCustomerOneTimeJobApprovalRefreshTrigger -= 1;
    },
  },
});

export const { setAppState, triggerPendingCustomerOTJApprovalRefresh } = appStateSlice.actions;

export default appStateSlice.reducer;
